/* eslint-disable no-barrel-files/no-barrel-files */
import { EntryType, AccountingPostingDocumentTypeEnum } from "@exonn/js-sdk";

export { EntryType, AccountingPostingDocumentTypeEnum };

export enum CreateAccountingPostingFormSearchParams {
  BankTransactionId = "bank_transaction_id",
  ShowAssignOrderForm = "show_assign_order_form",
}
